import { onViewLoad } from "jose_modern/on_view_load";
import {
  updateFacilityAllergensRecipePath,
  updateAllergensForRecipeIngredientAllergenPath,
  updateAllergensIngredientAllergenPath,
} from "routes";
import { AllergenInput, postAllergens, postFacilityAllergens, initToggles } from "./common.js";
import { Confirm } from "jose_modern/confirm";
import { safeSubmitForm } from "jose_modern/auto_submit.js";

function initIngredientGrid() {
  document.querySelectorAll(".ingredient-allergens").forEach((container) => {
    AllergenInput.bindAutosave(container, (allergens) => {
      const { recipeId, ingredientAllergenId } = container.dataset;

      updateAllergensOnIngredient(ingredientAllergenId, recipeId, allergens);
    });
  });
}

function initRecipeAllergens() {
  document.querySelectorAll(".recipe-allergens").forEach((container) => {
    AllergenInput.bindAutosave(container, (allergens) => {
      const { recipeId } = container.dataset;

      updateAllergensOnRecipe(recipeId, allergens);
    });
  });
}

function initLockToggle() {
  document.querySelectorAll("#recipe_lock_allergens").forEach((toggle) => {
    const submit = () => {
      safeSubmitForm(toggle.form);
    };

    toggle.addEventListener("click", async (e) => {
      let confirmed;
      const isUnlocking = !e.target.checked;
      if (isUnlocking) {
        confirmed = await Confirm.confirm(
          `If you disable locking, updating ingredient-level allergens on this
          or other allergen pages will automatically update the allergens for this recipe.
          <br>
          <br>
           Do you wish to continue?`,
          { confirm: "Yes, disable manual editing and automatically update" }
        );
      } else {
        confirmed = await Confirm.confirm(
          `If you lock the allergens, they will be set based on the allergens below.
          <br>
          <br>
          Updating ingredient-level allergens on this or other allergen pages
          will no longer update the allergens for this recipe.
          <br>
          <br>
          Are you sure you wish to continue?`,
          { confirm: "Yes, lock allergens and prevent updates" }
        );
      }

      if (confirmed) {
        submit();
      } else {
        e.target.checked = !e.target.checked;
        e.preventDefault();
      }
    });
  });
}

function initFacilityAllergens() {
  document.querySelectorAll(".facility-allergens").forEach((container) => {
    AllergenInput.bindAutosave(container, (allergens) => {
      const { recipeId } = container.dataset;

      updateFacilityAllergensOnRecipe(recipeId, allergens);
    });
  });
}

async function updateAllergensOnIngredient(ingredientAllergenId, recipeId, allergens) {
  const url = updateAllergensIngredientAllergenPath(ingredientAllergenId, { recipe_id: recipeId });

  await postAllergens(url, allergens);
}

async function updateAllergensOnRecipe(recipeId, allergens) {
  const url = updateAllergensForRecipeIngredientAllergenPath(recipeId);

  await postAllergens(url, allergens);
}

async function updateFacilityAllergensOnRecipe(recipeId, allergens) {
  const url = updateFacilityAllergensRecipePath(recipeId);

  await postFacilityAllergens(url, allergens);
}

onViewLoad("ingredient_allergens#index_for_recipe", () => {
  initIngredientGrid();
  initLockToggle();
  initRecipeAllergens();
  initToggles();
  initFacilityAllergens();
});

document.addEventListener("partial:replace", (e) => {
  if (e.partial === "ingredient_allergens/recipe_allergen_options") {
    initRecipeAllergens();
  }
});
